import React from 'react';
import { Navigate } from 'react-router-dom';

import { getToken } from '../../utils/utils.ts';

export function ProtectedRoute(props: Readonly<{ children: React.ReactNode }>): React.ReactNode {
  if (getToken()) {
    return props.children;
  }
  return <Navigate to="/login" />;
}
